var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var width = "60.7%";
var height = "6.4%";
var left = "18.7%";
var isExternal = true;
var iniTop = 12.4;
var padding = 19.8 - iniTop;
var links = [
    ["Supplier Security WebApp", "https://www.isflive.org/s/topic/0TO0J0000009AOCWA2/supply-chain"],
    ["ICS Insights series", "https://www.isflive.org/s/topic/0TO0J0000009AOWWA2/ics-security-support-community"],
    ["Threat Intelligence: React and prepare", "https://www.isflive.org/s/article/Threat-Intelligence-react-and-prepare"],
    ["ISF Aligned Tools Suite 2022", "https://www.isflive.org/s/isf-aligned-tools-suite"],
    ["Embedding Security into Agile Development: Ten principles for rapid improvement", "https://www.isflive.org/s/article/Embedding-Security-into-Agile-Development-Ten-principles-for-rapid-improvement-Report"],
    ["Standard of Good Practice for Information Security", "https://www.isflive.org/s/article/Standard-of-Good-Practice-for-Information-Security-2022-All-Files?topicId=0TO0J0000009AOIWA2"],
    ["Managing Cyber Threats During Periods of Instability", "https://www.isflive.org/s/cyber-resilience"],
    ["Threat Horizon 2022: The disintegration of trust", "https://www.isflive.org/s/article/Threat-Horizon-2024-the-disintegration-of-trust-report?topicId=0TO0J0000009AODWA2"],
    ["QIRA Assistant", "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology-Assistant"],
    ["Information Security in Mergers & Acquisitions", "https://www.isflive.org/s/article/Information-Security-in-Mergers-and-Acquisitions?topicId=0TO6M0000005B8PWAU"]
].map(function (line) { return ({
    label: line[0],
    href: line[1]
}); });
export default __spreadArray(__spreadArray([], links.map(function (cur, idx) {
    return __assign(__assign({ width: width, height: height, left: left, isExternal: isExternal, top: "".concat(iniTop + (padding * idx), "%") }, cur), { target: "_blank" });
}), true), [{
        width: "28.7%",
        height: "5.4%",
        left: "34.7%",
        isExternal: isExternal,
        top: "88%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }], false);
